import { getEnvironment } from '@toloka-tb/common/utils/environment';

import { sendTbApiRequest } from '../utils/sendTbApiRequest';

import { MOCK_EXPERIMENTS } from './experiments.constants';
import { type ExperimentsResponse } from './experiments.types';

export const getExperimentFeatures = async () => {
    if (getEnvironment() === 'dev') {
        return MOCK_EXPERIMENTS;
    }

    const response = await sendTbApiRequest<ExperimentsResponse>({
        endpointName: 'experiments.get-features',
        url: 'https://api-ui.toloka.ai/api/user/enabled-features',
        method: 'GET',
        credentials: 'include'
    });

    return response.features;
};
